import { DomainCriteria } from "../objects/domainCriteria";

export const EMPTY_DOMAIN_CRITERIA: DomainCriteria = {
    limit: 50,
    page: 0,
    order: 'asc',
    order_by: ''
}